import React, { useState } from 'react';
import './navbar.css';
import tailTraceIcon from '../assets/image.png';
import { Link } from 'react-router-dom';
import SubscribeModal from '../SubscribeModal/subscribemodal';
import { FiMenu, FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  // const [showModal, setShowModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="mainnavcontainer">
      <div className="navbarContainer">
        <Link className="logo" to="/" onClick={closeMenu}>
          <img className="tailTraceIcon" src={tailTraceIcon} alt="TailTrace Logo" />
        </Link>

        {/* Hamburger Icon */}
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>

        {/* Nav Links */}
        <div className={`navMenu ${menuOpen ? 'active' : ''}`}>
          <h2 className="navLinks" onClick={closeMenu}><Link to="/">Home</Link></h2>
          <h2 className="navLinks" onClick={closeMenu}><Link to="/features">Feature</Link></h2>
          <h2 className="navLinks" onClick={closeMenu}><Link to="/contact">Contact</Link></h2>
          <h2 className="navLinks" onClick={closeMenu}><Link to="/about">About</Link></h2>
          {/* <button className="downloadNow" onClick={() => { setShowModal(true); closeMenu(); }}>
            <h2 className='downloadText'>Subscribe</h2>
          </button> */}
          <button className="downloadNow" onClick={() => { 
            window.open('https://apps.apple.com/us/app/tailtrace-llc/id6751217826', '_blank');
            closeMenu(); 
          }}>
            <h2 className='downloadText'>Download</h2>
          </button>
        </div>
        {/* <SubscribeModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      </div>
    </div>
  );
};

export default Navbar;
